import { render } from "./SelectPOKJA.vue?vue&type=template&id=5da4ff9e"
import script from "./SelectPOKJA.vue?vue&type=script&lang=js"
export * from "./SelectPOKJA.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__